<ng-container>
  <div>
    <!--the outer div is necessary for correct padding and matching other div dls-->
    @if (siteKeyList?.length) {
      <dl id="siteKeys">
        <div
          class="d-flex align-items-center gap-3 justify-content-between mb-2"
        >
          <div>
            <dt>
              Site Keys
              @if (siteKeyList?.length == 20) {
                [Limit Reached]
              }
            </dt>
          </div>
          @if (
            siteKeyList?.length < 20 &&
            (isAdmin || isDispatchUser) &&
            showManageOption
          ) {
            <div>
              <span
                (click)="openSiteKeysTemplate(siteKeyRef)"
                class="ms-3 add-button"
              >
              </span>
            </div>
          }
        </div>
        <dd class="d-flex flex-wrap gap-2 overflow-25vh">
          @if (
            showManageOption &&
            (isAdmin || isDispatchUser) &&
            siteKeyList?.length > 5
          ) {
            <div>
              @if (showSearchField) {
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    id="searchSiteKeys"
                    autofocus
                    placeholder="Search"
                    [(ngModel)]="searchStr"
                    (input)="filterSiteKeys()"
                  />

                  @if (searchStr) {
                    <span class="input-group-text" (click)="searchStr = ''">
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              } @else {
                <div (click)="showSearchField = true" class="px-2 py-3">
                  <i
                    class="fa-solid fa-magnifying-glass text-secondary fs-4"
                  ></i>
                </div>
              }
            </div>
          }
          @for (
            siteKey of searchStr ? siteKeyFilteredList : siteKeyList;
            track siteKey
          ) {
            <div
              class="border px-2 py-1 rounded bg-secondary-subtle text-dark d-flex align-items-center"
            >
              <div class="d-flex align-items-center gap-3">
                <span
                  (click)="
                    siteKey?.id &&
                    (isAdmin || isDispatchUser) &&
                    showManageOption
                      ? openSiteKeysTemplate(siteKeyRef, siteKey)
                      : null
                  "
                >
                  <i
                    class="fa-solid fa-key"
                    [class.hover]="
                      siteKey?.id &&
                      (isAdmin || isDispatchUser) &&
                      showManageOption
                    "
                    [ngClass]="
                      siteKey?.master_key ? 'text-success' : 'text-warning'
                    "
                  ></i>
                </span>
                <div>
                  <div class="mono-font">
                    {{ siteKey?.value ? siteKey?.value : siteKey }}
                  </div>
                  @if (siteKey?.description) {
                    <div class="text-dark small-font">
                      {{ siteKey?.description }}
                    </div>
                  }
                  @if (siteKey?.master_key) {
                    <div class="text-dark text-center small-font">
                      Master Key
                    </div>
                  }
                </div>
                @if (siteKey?.file_url) {
                  <div>
                    <span
                      (click)="
                        onOpenFile(siteKey); $event.stopImmediatePropagation()
                      "
                      class="mx-3"
                    >
                      <i
                        class="fa-solid fa-file-image md-font-size text-dark"
                      ></i>
                    </span>
                  </div>
                }
                @if (
                  siteKey?.id && (isAdmin || isDispatchUser) && showManageOption
                ) {
                  <div
                    (click)="
                      deleteSiteKey(siteKey); $event.stopImmediatePropagation()
                    "
                  >
                    <span>
                      <i class="fa-solid fa-circle-minus text-danger"></i>
                    </span>
                  </div>
                }
              </div>
            </div>
          }
        </dd>
      </dl>
    } @else if (showManageOption) {
      <dl>
        <div>
          <div class="d-flex align-items-center">
            <dt>Site Keys</dt>
            @if (isAdmin || isDispatchUser) {
              <span
                class="ms-3 add-button"
                (click)="openSiteKeysTemplate(siteKeyRef)"
              ></span>
            }
          </div>
          <div
            class="d-flex"
            [ngClass]="isAdmin || isDispatchUser ? 'mt-2' : ''"
          >
            No site keys have been added yet.
          </div>
        </div>
      </dl>
    }
  </div>
</ng-container>
<ng-template #siteSelectionTemplate let-siteSelectionTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Select Sites
      <span class="float-end" (click)="siteSelectionTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <ng-template *ngTemplateOutlet="siteSearchSelectTemplate"></ng-template>
    </div>
    @if (!newKeyData?.master_key && newKeyData?.multiple_sites) {
      <span class="text-secondary ms-2 small fw-semibold text-end my-3"
        >Sites: {{ masterKeySelectedSites?.length }}</span
      >
    }
    <div class="mb-3">
      <button
        class="btn btn-success w-100 btn-lg"
        (click)="siteSelectionTemplateRef.close(true)"
      >
        Update
      </button>
    </div>
  </div>
</ng-template>
<ng-template #siteKeyRef let-data let-siteKeyRef="dialogRef">
  <div
    class="dialog-box card"
    [class.large-view]="
      newKeyData?.multiple_sites && !newKeyData?.master_key && largeView
    "
  >
    <div class="card-header">
      {{ newKeyData?.id ? "Update" : "Add" }} Site Key
      @if (selectedSite?.company_name && !newKeyData?.multiple_sites) {
        for <span> {{ selectedSite?.company_name }} </span>
      }
      <span class="float-end" (click)="siteKeyRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="d-flex mb-2">
      <div class="flex-grow-1">
        <ng-container>
          <div class="row row-cols-1 me-1">
            <div class="form-floating">
              <input
                [id]="'siteKey'"
                class="form-control"
                placeholder=" Key Identifier"
                maxlength="30"
                type="text"
                autocomplete="off"
                [(ngModel)]="newKeyData.value"
                [class.is-invalid]="!newKeyData.value"
              /><label> Key Identifier</label>
            </div>
            <div class="form-floating mb-2">
              <input
                [id]="'siteDescription'"
                class="form-control"
                placeholder="Description / Purpose"
                maxlength="100"
                type="text"
                autocomplete="off"
                [(ngModel)]="newKeyData.description"
              /><label>Description / Purpose</label>
            </div>

            <div class="d-flex mb-3 gap-1 flex-wrap row-gap-3 flex-column">
              <div>
                <div class="form-check d-flex align-items-center mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="newKeyData?.multiple_sites"
                    (change)="
                      newKeyData.multiple_sites = !newKeyData?.multiple_sites
                    "
                    type="checkbox"
                    id="multipleSiteKey"
                  />
                  <label
                    class="form-check-label ms-2"
                    for="multipleSiteKey"
                    [class.fw-semibold]="newKeyData?.multiple_sites"
                  >
                    Master Key (Add key to more than one site)
                    @if (
                      !newKeyData?.master_key && newKeyData?.multiple_sites
                    ) {
                      <span class="text-secondary ms-2 small fw-semibold"
                        >Sites: {{ masterKeySelectedSites?.length }}</span
                      >
                    }
                  </label>
                </div>

                @if (newKeyData?.multiple_sites) {
                  @if (!newKeyData?.master_key) {
                    @if (largeView) {
                      <ng-template
                        *ngTemplateOutlet="siteSearchSelectTemplate"
                      ></ng-template>
                    } @else {
                      <button
                        class="btn btn-primary w-100 btn-lg"
                        (click)="
                          openSiteSelectionTemplate(siteSelectionTemplate)
                        "
                      >
                        Update Sites
                      </button>
                    }
                  }
                  <div class="form-check d-flex align-items-center my-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="newKeyData?.master_key"
                      (change)="newKeyData.master_key = !newKeyData?.master_key"
                      type="checkbox"
                      id="masterSiteKey"
                    />
                    <label
                      class="form-check-label ms-2"
                      for="masterSiteKey"
                      [class.fw-semibold]="newKeyData?.master_key"
                    >
                      @if (selectedSite?.company?.company_name) {
                        Make available for all
                        {{ selectedSite?.company?.company_name }} sites
                      } @else {
                        Make available for all sites
                      }
                    </label>
                  </div>
                }
              </div>
            </div>
            <div>
              <input
                #fileInput
                id="fileInput"
                style="display: none; cursor: pointer"
                type="file"
                accept=".jpg, .jpeg, .png, .webp, .avif"
                (change)="handleFileInput($event)"
              />
            </div>

            <div
              class="d-flex align-items-center text-center flex-column gap-2 mb-3"
            >
              @if (newKeyData?.file_url) {
                <img src="{{ newKeyData?.file_url }}" width="200" />

                <button
                  type="button"
                  class="btn btn-outline-danger"
                  (click)="deleteSitePhoto()"
                >
                  Delete Photo
                </button>
              } @else {
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  (click)="selectFile()"
                >
                  Upload Photo (Optional)
                </button>
              }
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="row row-cols-2">
      <div class="col">
        <button class="btn btn-lg w-100 btn-dark" (click)="siteKeyRef.close()">
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          (click)="updateSiteKey()"
          [disabled]="!newKeyData?.value"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #siteSearchSelectTemplate>
  @if (!serverSiteListResponseReturned) {
    <div
      class="alert alert-primary my-2 d-flex justify-content-between align-items-center small-font py-1"
    >
      <div class="fw-bold">Fetching Data from Server</div>
      <div class="spinner-grow" role="status"></div>
    </div>
  } @else {
    @if (
      (serverSiteList?.length || uiCachedSiteList?.length) > 5 ||
      siteFilterStringValue
    ) {
      <div class="col-12 col-lg-6 my-2">
        <div class="input-group">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              placeholder="Search Filter"
              (input)="onSiteSearch($event)"
              [(ngModel)]="siteFilterStringValue"
            />
            <label>Search Filter</label>
          </div>

          @if (siteFilterStringValue) {
            <span
              class="input-group-text"
              (click)="onSiteSearch({ target: { value: '' } })"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </div>
    }
  }
  <div
    class="d-flex gap-2 flex-wrap"
    [ngClass]="largeView ? 'overflow-25vh' : 'overflow-45vh'"
  >
    @for (
      site of siteFilterStringValue
        ? siteFilteredList
        : serverSiteList?.length
          ? serverSiteList
          : uiCachedSiteList;
      track site?.id
    ) {
      <div
        (click)="updateSelectedSite(site)"
        [attr.role]="site?.disabled ? '' : 'button'"
        class="p-2 py-3 py-lg-2 border rounded bg-secondary-subtle text-dark pe-4 site-suggestion-width d-flex gap-2 align-items-center flex-grow-sm-1"
        [ngClass]="
          masterKeySelectedSiteIds?.includes(site?.id)
            ? 'fw-semibold'
            : 'opacity-75'
        "
      >
        <input
          type="checkbox"
          [checked]="masterKeySelectedSiteIds?.includes(site?.id)"
          [disabled]="disabledSiteIds?.includes(site?.id)"
        />
        <div class="fw-semibold">
          {{ site?.company_name }}
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- <ng-template let-dataItem="value" #siteSearchSelectTemplate>
  @if (dataItem?.search) {
    @if (totalSiteCount > 5|| siteFilterStringValue) {
      <div class="input-group my-2">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            placeholder="Search Filter"
            (input)="onSiteSearch($event)"
            [(ngModel)]="siteFilterStringValue"
          />
          <label>Search Filter</label>
        </div>

        @if (siteFilterStringValue) {
          <span
            class="input-group-text"
            (click)="onSiteSearch({ target: { value: '' } })"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
    }

    @if (siteListData?.length) {
      @if ( siteListData?.length > 1 && !allSitesAdded) {
        <div class="text-end my-2">
          <button
            (click)="addAllsites()"
            class="btn btn-warning btn-sm"
            [disabled]="masterKeySelectedSites?.length >= 250"
          >
            Add All
            <span class="fs-6 fw-semibold px-2">{{
              siteListData?.length
            }}</span>
          </button>
        </div>
      }
      <div
        class="mb-2"
        [ngClass]="
          totalSiteCount > 10
            ? 'sites-list-with-search'
            : 'sites-list-without-search'
        "
      >
        @for (site of siteListData; track $index) {
            <div class="d-flex align-items-center p-2 mb-2 gap-2">
              <div
                class="flex-grow-1"
                [class.added-site]="site?.id === lastAddedSiteID"
              >
                <div class="fw-semibold">
                  {{ site?.company_name }}
                </div>
              </div>

              <div (click)="addSelectedSite(site)">
                <button
                  class="btn btn-primary btn-sm m-0"
                  [disabled]="masterKeySelectedSites?.length >= 250||masterKeySelectedSiteIds?.includes(site?.id)"
                >
                  Add
                </button>
              </div>
            </div>
        }
      </div>
      @if (siteListData?.length < totalSiteCount) {
        <div class="text-center my-2">
          <button
            (click)="
              sitePreviousCount = siteRowsCount + sitePreviousCount;
              getSiteList()
            "
            class="btn btn-secondary btn-md px-4"
          >
            Load More
          </button>
        </div>
      }
    } @else if (siteFilterStringValue) {
      <div class="alert alert-primary fw-bold">
        No Records Match Your Search Criteria
      </div>
    }
  } @else {
    @if (masterKeySelectedSites?.length) {
      <div
        class="d-flex justify-content-between m-1 p-1 ps-2 border rounded align-items-center"
      >
        <div class="fs-5">
          <span class="text-secondary"> Sites:</span>
          <span class="fw-semibold"> {{ masterKeySelectedSites?.length }}</span>
        </div>
      </div>
    }

    <div class="sites-list-without-search">
      <div>
        @for (
          site of masterKeySelectedSites;
          track $index;
          let isLastItem = $last
        ) {
          <div class="d-flex align-items-center p-2 mb-2 gap-2" >
            <div
              class="flex-grow-1"
              [class.added-site]="site?.id === lastAddedSiteID && isLastItem"
            >
              <div class="fw-semibold">
                {{ site?.company_name }}
              </div>
            </div>
            @if(!site?.disabled){

            <div (click)="removeSelectedSite($index)">
              <button class="btn btn-danger btn-sm m-0">Del</button>
            </div>}
          </div>
        }
      </div>
      <div id="lastElementAnchor">
      </div>
    </div>
  }
</ng-template> -->
